export enum QuestionTableColumn {
  Mastery = "mastery",
  Accuracy = "accuracy",
  Correct = "correct",
}
